import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-form-control-radio o-grid__cell o-grid__cell--4"
}
const _hoisted_2 = ["id", "value", "aria-label", "data-cy"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "base-container active" }
const _hoisted_5 = { class: "msg-container" }
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "svg-container" }
const _hoisted_8 = {
  class: "base",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 282.697 265.737",
  width: "100%",
  "aria-hidden": "true"
}
const _hoisted_9 = ["fill"]
const _hoisted_10 = {
  class: "rect",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 282.697 265.737",
  width: "100%",
  "aria-hidden": "true"
}
const _hoisted_11 = ["fill"]
const _hoisted_12 = { class: "c-form-control-radio__label-text" }
const _hoisted_13 = { class: "payOnCheckout" }
const _hoisted_14 = {
  key: 0,
  class: "tarifauswahl_produktlinie__zusatztext"
}
const _hoisted_15 = {
  key: 1,
  class: "c-form-control-radio o-grid__cell twoCols o-grid__cell--4"
}
const _hoisted_16 = ["id", "value", "aria-label", "data-cy"]
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "base-container active" }
const _hoisted_19 = { class: "msg-container" }
const _hoisted_20 = { class: "msg" }
const _hoisted_21 = { class: "svg-container" }
const _hoisted_22 = {
  class: "base",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 280 160",
  width: "100%",
  "aria-hidden": "true"
}
const _hoisted_23 = ["fill"]
const _hoisted_24 = {
  "aria-hidden": "true",
  class: "rect",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 280 131",
  width: "100%"
}
const _hoisted_25 = ["fill"]
const _hoisted_26 = { class: "c-form-control-radio__label-text" }
const _hoisted_27 = { class: "payOnCheckout" }
const _hoisted_28 = {
  key: 0,
  class: "tarifauswahl_produktlinie__zusatztext"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.produktLinien === 3)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          id: _ctx.props.tarifauswahlInformation.produktlinie,
          name: "produktLinie",
          type: "radio",
          tabindex: "0",
          autofocus: "",
          value: _ctx.props.tarifauswahlInformation.produktlinie,
          "aria-label": _ctx.props.tarifauswahlInformation.produktlinie,
          class: "gevng-step2-tariffchooser__input c-form-control-radio__input js-tariff-radio1",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.produktLinie) = $event)),
          "data-cy": _ctx.props.tarifauswahlInformation.produktlinie
        }, null, 8, _hoisted_2), [
          [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.produktLinie]
        ]),
        _createElementVNode("label", {
          class: "c-form-control-radio__label",
          for: _ctx.props.tarifauswahlInformation.produktlinie
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.piniaStore.state.isMakler === true ? "" : "Ihre ") + "Auswahl", 1)
            ]),
            _createElementVNode("span", _hoisted_7, [
              (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                _createElementVNode("g", null, [
                  _createElementVNode("polygon", {
                    points: "3 215.215 3 3 279.697 3 279.697 215.212 141.63 262.566 3 215.215",
                    fill: _ctx.props.tarifauswahlInformation.tarifFarbe
                  }, null, 8, _hoisted_9),
                  _cache[2] || (_cache[2] = _createElementVNode("path", {
                    d: "M276.7,6V213.069L141.628,259.4,6,213.069V6H276.7m6-6H0V217.36l4.061,1.387,135.627,46.326,1.944.664,1.942-.667,135.07-46.325,4.053-1.39V0Z",
                    fill: ""
                  }, null, -1))
                ])
              ])),
              (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                _createElementVNode("g", null, [
                  _createElementVNode("rect", {
                    x: "3",
                    y: "3",
                    width: "276.697",
                    height: "213.069",
                    fill: _ctx.props.tarifauswahlInformation.tarifFarbe
                  }, null, 8, _hoisted_11),
                  _cache[3] || (_cache[3] = _createElementVNode("path", {
                    d: "M276.7,6V213.069H6V6H276.7m6-6H0V219.069H282.7V0Z",
                    fill: ""
                  }, null, -1))
                ])
              ]))
            ])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("span", {
            "aria-hidden": "true",
            class: "c-form-control-radio__icon"
          }, null, -1)),
          _createElementVNode("span", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              (!_ctx.piniaStore.state.isMakler)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.props.tarifauswahlInformation.tarifBeschreibung), 1))
                : _createCommentVNode("", true),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.piniaStore.state.preise.produktLinien[_ctx.props.tarifauswahlInformation.tarifNummer].nameProduktLinie) + " ", 1),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(
              _ctx.piniaStore.state.preise.produktLinien[_ctx.props.tarifauswahlInformation.tarifNummer].gemZahlungsweise,
            )), 1)
            ])
          ])
        ], 8, _hoisted_3)
      ]))
    : (_ctx.produktLinien === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            id: _ctx.props.tarifauswahlInformation.produktlinie,
            name: "produktLinie",
            type: "radio",
            value: _ctx.props.tarifauswahlInformation.produktlinie,
            "aria-label": _ctx.props.tarifauswahlInformation.produktlinie,
            class: "gevng-step2-tariffchooser__input c-form-control-radio__input js-tariff-radio1",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.produktLinie) = $event)),
            "data-cy": _ctx.props.tarifauswahlInformation.produktlinie
          }, null, 8, _hoisted_16), [
            [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.produktLinie]
          ]),
          _createElementVNode("label", {
            class: "c-form-control-radio__label",
            for: _ctx.props.tarifauswahlInformation.produktlinie
          }, [
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.piniaStore.state.isMakler ? "" : "Ihre ") + "Auswahl", 1)
              ]),
              _createElementVNode("span", _hoisted_21, [
                (_openBlock(), _createElementBlock("svg", _hoisted_22, [
                  _createElementVNode("g", null, [
                    _createElementVNode("polygon", {
                      points: "1.9,129.5 1.9,1.7 278.1,1.7 278.1,129.5 140,158.2",
                      fill: _ctx.props.tarifauswahlInformation.tarifFarbe
                    }, null, 8, _hoisted_23),
                    _cache[7] || (_cache[7] = _createElementVNode("path", {
                      d: "M276.1,3.5v124.5L140,156.5L3.9,128.1V3.5H276.1 M280,0H0v130.9L140,160l140-29.1V0L280,0z",
                      fill: ""
                    }, null, -1))
                  ])
                ])),
                (_openBlock(), _createElementBlock("svg", _hoisted_24, [
                  _createElementVNode("g", null, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "3",
                      width: "276.697",
                      height: "213.069",
                      fill: _ctx.props.tarifauswahlInformation.tarifFarbe
                    }, null, 8, _hoisted_25),
                    _cache[8] || (_cache[8] = _createElementVNode("path", {
                      d: "M276.7,6V213.069H6V6H276.7m6-6H0V219.069H282.7V0Z",
                      fill: ""
                    }, null, -1))
                  ])
                ]))
              ])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("span", {
              "aria-hidden": "true",
              class: "c-form-control-radio__icon"
            }, null, -1)),
            _createElementVNode("span", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, [
                (!_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.props.tarifauswahlInformation.tarifBeschreibung), 1))
                  : _createCommentVNode("", true),
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.piniaStore.state.preise.produktLinien[_ctx.props.tarifauswahlInformation.tarifNummer].nameProduktLinie) + " ", 1),
                _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(
              _ctx.piniaStore.state.preise.produktLinien[_ctx.props.tarifauswahlInformation.tarifNummer].gemZahlungsweise,
            )), 1)
              ])
            ])
          ], 8, _hoisted_17)
        ]))
      : _createCommentVNode("", true)
}